<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Registro de Peso</h3>
        </div>
        <div class="col text-right">
          <router-link to="/pesos" class="text-light"><base-button size="sm" type="primary">Ver todos</base-button></router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light"
                  :data="tableData">
        <template slot="columns">
          <th>Fecha</th>
          <th>Peso</th>
          
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            {{row.fecha}}
          </th>
          <td>
            {{row.peso}}Kg
          </td>
        </template>

      </base-table>
    </div>

  </div>
</template>
<script>
import { db } from "../../firebaseDb";
import { auth } from "../../firebaseDb";
  export default {
    name: 'pesos-table-min',
    data() {
      return {
        user: auth.currentUser,
        tableData: [
          
        ]
      }
    },
    created: function () {
      db.collection("users")
        .doc(this.user.uid)
        .collection("pesos")
        .orderBy("fecha", "desc").limit(7)
        .onSnapshot({ includeMetadataChanges: true }, (snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;

            item.fecha = item.fecha.toDate().toLocaleDateString("es-ES");

            this.tableData.push(item);
          });
      });
    },

  }
</script>
<style>
</style>
